import axios from 'axios'
import Locale from '@serv/Locale'
import Logging from '@serv/Logging'
import NotifyService from '@serv/NotifyService'
import { ref } from 'vue'
import { storeToRefs } from 'pinia'

export default function useDownloadPdf() {
    const isPdfDownloading = ref(false)

    const downloadPdf = async (url: string, filename: string): Promise<void> => {
        if (!filename) {
            const error = `No filename specified - please specify a filename. Trying to query ${url}`
            Logging.error(error)

            return Promise.reject(new Error(error))
        }

        isPdfDownloading.value = true

        const { useImpersonationStore } = await import('@/stores/impersonation')
        const { impersonatedUser } = storeToRefs(useImpersonationStore())

        return axios
            .get(url, {
                responseType: 'blob',
                ...(impersonatedUser.value
                    ? { headers: { 'Impersonate-User': `user_id-${impersonatedUser.value.userId}` } }
                    : {})
            })
            .then(response => {
                const pdfUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
                const link = document.createElement('a')
                link.href = pdfUrl
                link.setAttribute('download', `${filename}.pdf`)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
            .catch(error => {
                Logging.error(`Error downloading PDF from ${url}: ${error.message}`)
                NotifyService.error(Locale.getLanguageItem('errorDownloadPdfFailed'))
            })
            .finally(() => {
                isPdfDownloading.value = false
            })
    }

    return {
        downloadPdf,
        isPdfDownloading
    }
}
